import React, { useContext, useEffect, useState } from "react";
// Soft UI Dashboard PRO React example components

import Carousel from "components/UpStyled/Carousel";
import SuiButton from "components/SuiButton";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiInput from "components/SuiInput";
import Checkbox from "@mui/material/Checkbox";

// Overview page components
import Header from "pages/ma/profile/components/Header";
import ProjectRequirement from "pages/ma/profile/components/ProjectRequirement";
import ServicesWeOffer from "pages/ma/profile/components/ServicesWeOffer";
import OurSpecialties from "pages/ma/profile/components/OurSpecialties";
import AboutOurCompany from "pages/ma/profile/components/AboutOurCompany";
import Gallery from "pages/ma/profile/components/Gallery";

import PulseLoader from "react-spinners/PulseLoader";
import ReviewsBoard from "pages/ma/profile/components/ReviewsBoard";

const ManufacturerDetail = ({ user }) => {
  const store = user?.stores && user?.stores.length > 0 ? user.stores[0] : { tags: [] };
  if (!store["metadata"]) {
    store["metadata"] = {
      address: {},
      service: [],
      reviews: [],
      following: [],
      follower: [],
    };
  }

  return (
    <div>
      {user && user.id ? (
        <SuiBox>
          <Header
            store={store}
            editable={false}
            hideButton={true}
            statusBar={true}
            isSocial={true}
          />

          <SuiBox my={3}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12} md={7.5} lg={7.5}>
                <AboutOurCompany store={store} tags={[]} editable={false} account={user} />
                <Grid container spacing={3} mt={1}>
                  <Grid item xs={12} sm={12} md={5} lg={5}>
                    <ProjectRequirement store={store} editable={false} />
                  </Grid>
                  <Grid item xs={12} sm={12} md={7} lg={7}>
                    <OurSpecialties store={store} editable={false} />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} sm={12} md={4.5} lg={4.5}>
                <ServicesWeOffer store={store} editable={false} />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Gallery store={store} editable={false}></Gallery>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <ReviewsBoard store={store}></ReviewsBoard>
              </Grid>
            </Grid>
          </SuiBox>
        </SuiBox>
      ) : (
        <div>
          <PulseLoader />
          <SuiTypography variant="text">Loading...</SuiTypography>
        </div>
      )}
    </div>
  );
};

export default ManufacturerDetail;
